// Custom jQuery for Envy Shopify Theme, Designed and Coded by Nine (http://www.wearenine.com)

// Shopping Cart jQuery popup

$(document).ready(function () {
    $('.show-shopping-cart').click(function (e) {
        $("#minicart").toggle();
    });

    $('.close-shopping-cart').click(function (e) {
        $('#minicart').toggle();
    });
});

// FlexSlider

$(window).load(function() {
	$('.flexslider').flexslider({
		animation: "slide",
		directionNav: true,
		controlNav: false,
		controlsContainer: ".flexslider-container"
  });
});

// Superfish Menu

$(function() {
	$('ul#product-nav').superfish({
		delay: 100,
		animation: {opacity:'show',height:'show'}, 
	    speed: 'fast' 
	});
	$("ul#product-nav li").css({ "overflow":"visible"});
});

$(function() {
	$('ul#central-menu').superfish({
		delay: 100,
		animation: {opacity:'show',height:'show'}, 
	    speed: 'fast' 
	});
	$("ul#central-menu li").css({ "overflow":"visible"});
});

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});